import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import {
  ProcessGuideBanner,
  ProcessGuideDialog,
  ProcessGuideTrigger,
} from "../../../library/Dialog";

const GUIDE_TITLE = "AI Auto-Classify guide";

const getGuideFlowIndex = ({
  activeStep = 0,
  isClassifying = false,
  classificationComplete = false,
} = {}) => {
  if (isClassifying || classificationComplete) return 2;
  if (activeStep <= 0) return 0;
  if (activeStep === 1) return 1;
  return 3;
};

const classifyGuideProps = {
  title: GUIDE_TITLE,
  titleIcon: AutoAwesomeIcon,
  tabsAriaLabel: "Classification stages",
  closeTooltip: "Close guide",
};

const ClassifyProcessGuideDialog = (props) => (
  <ProcessGuideDialog {...classifyGuideProps} {...props} />
);

const ClassifyProcessGuideTrigger = (props) => (
  <ProcessGuideTrigger
    {...classifyGuideProps}
    tooltip='Open AI Auto-Classify guide'
    {...props}
  />
);

const ClassifyProcessGuideBanner = (props) => (
  <ProcessGuideBanner
    {...classifyGuideProps}
    description='Review the four-step workflow and guidance for each stage.'
    infoTooltip='Review the complete upload, mapping, classification, and apply workflow.'
    {...props}
  />
);

export {
  ClassifyProcessGuideBanner,
  ClassifyProcessGuideDialog,
  ClassifyProcessGuideTrigger,
  getGuideFlowIndex,
};
export default ClassifyProcessGuideTrigger;
